import { User } from "../user/user";
import { Media } from "../assets/media";

export interface Product {
	
	id: number;
	name: string;
	description?: string;
	fullDescription?: string;

	merchant?: User;

	// Price
	price: number;
	originalPrice?: number;
	discount?: number;
	category: string;
	
	// Stock
	inStock: boolean;
	stockQuantity: number;
	
	// Media
	media: Media;

	rating: number; // 1-5 stars
	reviewsCount: number;

	// Type
	type: ProductType;

	// Additional Info
	tags: string[];
	featured: boolean;
	createdAt: string;
	updatedAt: string;
}

export function getMerchantName(product: Product): string {
	return product && product.merchant ? `${product.merchant.firstName} ${product.merchant.lastName}` : '';
}

export function getProductImageUrl(product: Product): string {
	return product.media?.cover?.url || product.media?.photos?.[0]?.url || '';
}

export function getProductImages(product: Product): string[] {
	const images: string[] = [];
	
	if (product.media?.photos) {
		product.media.photos.forEach(photo => {
			if (photo.url && !images.includes(photo.url)) {
				images.push(photo.url);
			}
		});
	}
	
	return images;
}

export enum ProductType {
	BOOK = 'books',
	DEVOTIONALS = 'devotionals',
	AUDIO = 'audio',
	VIDEO = 'video',
	MUSIC = 'music',
	ART = 'art',
	GIFTS = 'gifts',
	OTHER = 'other',
	ALL = 'all',
}